import React from "react";
import HeroSec from "../heroSec";
import Feature from "../feature";
import Works from "../howItWorks";
import Stores from "../stores";
import MobileSection from "../mobileSection";
import Reviews from "../reviews";
import Download from "../download";
import { useMediaQuery } from "@mui/material";

const Home = () => {
  const isMobile = useMediaQuery("(max-width:640px)");

  const mobileBg = {
    backgroundImage: isMobile ? "url('/img/webpImg/mobileBg.webp')" : "none",
  };
  return (
    <div className="flex flex-col gap-[20px] md:gap-[84px] ">
      <div className="px-4 sm:px-8 lg:px-28 flex flex-col gap-[20px] md:gap-[84px]  ">
        <HeroSec />
        <Feature />
      </div>

      <Works />
      <div style={mobileBg} className="flex flex-col gap-[30px]">
        <Stores />
        <MobileSection />
      </div>
      <Reviews />
      <Download />
    </div>
  );
};

export default Home;
